import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
const OurStrength = () => {
    return (
        <>

            <section className="section-sp1">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h1 className="title-head text-center">Our Strength</h1>
                            <div className="row">
                                <div className="col-lg-3 pt-4">
                                    <div className="services-bx">
                                        <img src="https://reliablekota.com/images/icon/presentation.png" alt="" className='course-icon' />
                                        <h5>Pioneering</h5>
                                        <h4>Faculty Team</h4>
                                    </div>
                                </div>
                                <div className="col-lg-3 pt-4">
                                    <div className="services-bx">
                                        <img src="https://reliablekota.com/images/icon/study.png" alt="" className='course-icon' />
                                        <h5>Well Researched</h5>
                                        <h4>Study Material</h4>
                                    </div>
                                </div>
                                <div className="col-lg-3 pt-4">
                                    <div className="services-bx">
                                        <img src="https://reliablekota.com/images/icon/student.png" alt="" className='course-icon' />
                                        <h5>Regular & Periodic</h5>
                                        <h4>Assessments</h4>
                                    </div>
                                </div>
                                <div className="col-lg-3 pt-4">
                                    <div className="services-bx">
                                        <img src="https://reliablekota.com/images/icon/customer.png" alt="" className='course-icon' />
                                        <h5>Student</h5>
                                        <h4>Care & Support</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default OurStrength